import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import { CancelTokenSource } from 'axios';
import InvoiceStatistic2bTableSegment
  from 'components/billing/invoice-statistic/segments/InvoiceStatistic2bTableSegment';
import InvoiceStatistic2OptionsSegment
  from 'components/billing/invoice-statistic/segments/InvoiceStatistic2OptionsSegment';
import PraxStyledSegment from 'components/layout/PraxStyledSegment';
import StyledErrorMessage from 'components/layout/StyledErrorMessage';
import React, { Component } from "react";
import { MessageSourceProps, withMessages } from "react-message-source";
import { RouterProps } from 'react-router';
import { Divider } from 'semantic-ui-react';
import axios from 'services/http';
import { getAllTariffs } from 'services/tariffServices';
import styled from 'styled-components';
import {
  InvoiceStatistic2Request,
  InvoiceStatisticData,
  InvoiceStatisticGroupData,
  TariffDto
} from 'ts-types/api.types';

const StyledSegment = styled(PraxStyledSegment)`
  &.ui.segment {
    margin-top: 0;
    overflow: auto;
  }
`;

interface Props extends AuthConsumerRenderProps, MessageSourceProps, RouterProps {
}

interface State {
  invoiceStatisticData?: Partial<InvoiceStatisticGroupData>,
  dataLoading: boolean,
  formData?: Partial<InvoiceStatistic2Request>,
  tariffs: TariffDto[],
  groupByInterrupted: boolean,
  errorMessage?: string,
  cancelTokenSource: CancelTokenSource
}

class InvoiceStatistic2View extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const cancelTokenSource = axios.CancelToken.source();

    this.state = {
      dataLoading: false,
      tariffs: [],
      groupByInterrupted: true,
      cancelTokenSource: cancelTokenSource
    };

  }

  componentDidMount() {
    getAllTariffs(this.state.cancelTokenSource)
        .then(tariffs => {
          this.setState({tariffs});
        })
  }

  initialInvoiceStatisticDataValues = (): Partial<InvoiceStatisticData>[] => {
    const invoiceStatisticData = {
      totalOpenByTreatmentDate: undefined,
      totalByTreatmentDate: undefined,
      totalByBillDate: undefined,
      totalByPaymentDate: undefined,
      totalByStornoDate: undefined
    };

    return [invoiceStatisticData];
  };

  setFormDataValues = (formData: InvoiceStatistic2Request): void => {
    this.setState({
      formData: formData
    });
  }

  setErrorMessage = (errorMessage?: string) => {
    this.setState({
      errorMessage: errorMessage
    });
  };

  onFilterInvoiceStatisticData = (invoiceStatisticData: InvoiceStatisticGroupData) => {
    this.setState({
      invoiceStatisticData: invoiceStatisticData
    })
  };

  onChangeGroupByInterrupted = (groupByInterrupted: boolean) => {
    this.setState({
      groupByInterrupted: groupByInterrupted
    })
  }

  onInvoiceStatisticLoadingChange = (dataLoading: boolean) => {
    this.setState({
      dataLoading: dataLoading
    })
  };

  render(): React.ReactElement {

    const {
      invoiceStatisticData,
      formData,
      dataLoading,
      errorMessage
    } = this.state;

    const groups = [];
    if (formData) {
      if (formData.groupByYear) {
        groups.push("period-year");
      }
      if (formData.groupByQuarter) {
        groups.push("period-quarter");
      }
      if (formData.groupByMonth) {
        groups.push("period-month");
      }
      if (formData.groupByTariff) {
        groups.push("tariff");
      }
      if (formData.groupByInterrupted) {
        groups.push("interrupted");
      }
      groups.push("vat-rate");
    }

    return (
        <StyledSegment>
          {errorMessage
              && (
                  <StyledErrorMessage onDismiss={() => this.setErrorMessage()} style={{margin: 0}}>
                    {errorMessage}
                  </StyledErrorMessage>
              )
          }

          <InvoiceStatistic2OptionsSegment
              onFilterInvoiceStatisticData={this.onFilterInvoiceStatisticData}
              onFilterInvoiceStatisticDataOnlyByTreatmentDate={this.onFilterInvoiceStatisticData}
              onInvoiceStatisticLoadingChange={this.onInvoiceStatisticLoadingChange}
              setFormDataValues={this.setFormDataValues}
              onChangeGroupByInterrupted={this.onChangeGroupByInterrupted}
              setErrorMessage={this.setErrorMessage}
          />

          <Divider/>

          {
              invoiceStatisticData && formData &&
              <InvoiceStatistic2bTableSegment
                  invoiceStatisticData={invoiceStatisticData}
                  groups={groups}
                  searchRequest={formData}
                  dataLoading={dataLoading}
                  tariffs={this.state.tariffs}
                  setErrorMessage={this.setErrorMessage}/>
          }

        </StyledSegment>
    );
  }

}

export default withAuthContext(withMessages(InvoiceStatistic2View));
